import React from 'react';
import App from './App';
import store from './store';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { getCurrentLang, getCurrentMessages } from 'src/locales';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <IntlProvider locale={getCurrentLang()} messages={getCurrentMessages()}>
      <App />
    </IntlProvider>
  </Provider>
);
